import { PropsWithChildren, useContext, useEffect, useState } from "react";
import * as Icon from "@ant-design/icons";
import InputField from "./InputField";
import inputStyle from "./InputStyles.module.css";
import styles from "./Webhook.module.css";
import { FormContext } from "./FormField";

const HeaderFormConp = ({
  onValue,
  onName,
  onRemove,
  addHeader,
  index,
  initialValue,
}: PropsWithChildren<{
  onValue: (value: any) => void;
  onName: (value: any) => void;
  onRemove: (index: number) => void;
  addHeader?: () => void;
  index: number;
  initialValue?: [any, any];
}>) => {
  return (
    <div className="flexRow">
      <div className="flexRow">
        <div className="flex1">
          <InputField
            initialValue={initialValue?.[0]}
            inputClassName={inputStyle.input}
            onChange={(e: any) => onName({ value: e.target.value, index })}
          />
        </div>
        <div className="flex1">
          <InputField
            initialValue={initialValue?.[1]}
            inputClassName={inputStyle.input}
            onChange={(e: any) => onValue({ value: e.target.value, index })}
          />
        </div>
      </div>
      {Number(index) > 0 ? (
        <div>
          <button
            type="button"
            onClick={() => onRemove(index)}
            className={styles.actionButton}
          >
            <Icon.MinusCircleFilled
              style={{
                color: "#8B0000",
              }}
            />
          </button>
        </div>
      ) : (
        <div>
          <button
            type="button"
            className={styles.actionButton}
            onClick={addHeader}
          >
            <Icon.PlusCircleFilled
              style={{
                color: "#1677ff",
              }}
            />
          </button>
        </div>
      )}
    </div>
  );
};

/**
 * --------------------------
 * Request header main component
 * ----------------------------
 */

function RequestHeader() {
  const { fields, setValue } = useContext(FormContext);
  const [headers, setHeaders] = useState([HeaderFormConp]);

  useEffect(() => {
    if (Array.isArray(fields.headers)) {
      if (fields.headers.length) {
        setHeaders(
          Array(fields.headers.length)
            .fill(0)
            .map(() => HeaderFormConp)
        );
      }
    }
  }, [fields]);

  const handleHeaderName = (obj: any) => {
    let hdata: any[] = [];
    if (Array.isArray(fields.headers)) {
      hdata = [...fields.headers];
    }
    if (!Array.isArray(hdata[obj.index])) {
      hdata[obj.index] = [];
    }

    hdata[obj.index][0] = obj.value;
    setValue({ headers: hdata });
  };

  const handleHeaderValue = (obj: any) => {
    let hdata: any[] = [];
    if (Array.isArray(fields.headers)) {
      hdata = [...fields.headers];
    }
    if (!Array.isArray(hdata[obj.index])) {
      hdata[obj.index] = [];
    }

    hdata[obj.index][1] = obj.value;
    setValue({ headers: hdata });
  };

  const handleRemoveHeader = async (index: number) => {
    if (headers.length <= 1) return;
    setHeaders((current) => current.filter((_, i) => i !== index));
    if (Array.isArray(fields.headers)) {
      let hdata: any = [...fields.headers.filter((_, i) => i !== index)];
      setValue({ headers: hdata });
    }
  };

  return (
    <div className={styles.card}>
      <div>
        <h2>Encabezado de solicitud</h2>
      </div>
      {headers.map((Header, index) => {
        let initialValue: any = [];
        if (Array.isArray(fields.headers)) {
          if (fields.headers[index]) {
            initialValue = fields.headers[index];
          }
        }

        return (
          <Header
            initialValue={initialValue}
            index={index}
            onName={handleHeaderName}
            onValue={handleHeaderValue}
            onRemove={handleRemoveHeader}
            key={`${JSON.stringify(Header)}`}
            addHeader={() =>
              setHeaders((current: any) => [...current, HeaderFormConp])
            }
          />
        );
      })}
    </div>
  );
}

export default RequestHeader;
